import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('filled', 'crop-7-5-filled', 'Crop75Filled', [["path",{"d":"M18 5a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z"}]]);